module.exports = __webpack_public_path__ + "img/squarelogo.8cd00cc1.png";